import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./link.html";
import { IS_MFE_ACTIVE } from '~/modules/config';
import { isExternalLink } from '~/modules/helpers/navigationHelper';
import { navigate } from '~/modules/stores/routerStore';
import { isAgentExchange } from '~/modules/utilities/router';
class Link extends LightningElement {
  constructor(...args) {
    super(...args);
    /**
     * By default the wds-link component will extract the href from its slotted anchor tag.
     *
     * Unfortunately, due to LWC limitations this only works if the href is static (does not change from render to render).
     * If the URL needs to change, you must provide the href directly to the wds-link component.
     *
     * It doesn't hurt to provide the href in addition to setting it in the anchor child element.
     * So it's probably a good idea to always do it to avoid unexpected behavior.
     */
    this.href = void 0;
    this.label = void 0;
    this.name = void 0;
    this.customAriaLabel = void 0;
    this.target = void 0;
    this.i18nMessage = void 0;
    this.handleClick = event => {
      // Let the browser handle the behavior when the link is not in our page
      if ((isExternalLink(this.destination) || IS_MFE_ACTIVE) && !isAgentExchange()) {
        return;
      }
      event.preventDefault();
      navigate(this.destination);
    };
  }
  renderedCallback() {
    if (!this.i18nMessage && !this._destination) {
      const anchor = this.querySelector('a');
      if (anchor) {
        // @ts-expect-error * Automated Type Error Fix
        this._destination = anchor.getAttribute('href');
        anchor.onclick = this.handleClick;
      }
    }
  }
  get destination() {
    return this.href || this._destination;
  }
  isAnchorElement(element) {
    return element instanceof HTMLAnchorElement;
  }
  customEventGenerator(eventName) {
    return new CustomEvent(eventName, {
      bubbles: true,
      composed: true
    });
  }
  handleAnalytics(event) {
    event.detail.link = {
      callToAction: {
        url: this.destination,
        label: this.label,
        name: this.name || this.label
      }
    };
  }
  handleI18nLinkClicked(event) {
    const analyticsEvent = new CustomEvent('analytics', {
      bubbles: true,
      composed: true,
      detail: {
        elementType: 'link',
        eventType: 'click',
        link: {
          callToAction: {
            url: event.detail?.eventNameOrUrl,
            label: event.detail?.label,
            name: this.name
          }
        }
      }
    });
    this.dispatchEvent(analyticsEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Link, {
  publicProps: {
    href: {
      config: 0
    },
    label: {
      config: 0
    },
    name: {
      config: 0
    },
    customAriaLabel: {
      config: 0
    },
    target: {
      config: 0
    },
    i18nMessage: {
      config: 0
    }
  },
  fields: ["handleClick"]
});
const __lwc_component_class_internal = _registerComponent(Link, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;